"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Parser = _interopRequireDefault(require("@/components/FormGenerator/components/parser/Parser"));
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var selfUtil = _interopRequireWildcard(require("@/utils/ZBKJIutil.js"));
var systemFormConfigApi = _interopRequireWildcard(require("@/api/systemFormConfig.js"));
var systemSettingApi = _interopRequireWildcard(require("@/api/mallDefaultSetting.js"));
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  components: {
    parser: _Parser.default
  },
  data: function data() {
    return {
      onlyCanView: false,
      loading: false,
      integrityLoading: false,
      integrityMap: {},
      formConf: {
        content: {
          fields: []
        },
        id: null,
        render: false,
        isEdit: false
      },
      formConfChild: {
        content: {
          fields: []
        },
        id: null,
        render: false,
        isEdit: false
      },
      activeNamel1: null,
      activeNamel2: '',
      // 针对文件特殊处理
      treeList: [],
      editDataChild: {},
      isCreate: 0,
      currentEditId: null,
      currentEditData: null,
      initTenantLoadingIds: {},
      syncingTenantFieldName: '',
      tenantIssueDialogVisible: false,
      tenantIssueDialogTitle: '租户配置 — 明细',
      tenantIssueTableRows: [],
      tenantIssueDialogEmptyText: ''
    };
  },
  computed: {
    /** 全租户该表单无行时不在标签上标红，仍展示问号与表单项「补租户」 */tenantFieldIssueHighlightForParser: function tenantFieldIssueHighlightForParser() {
      var row = this.integrityRow(this.currentEditId);
      if (!row) return true;
      var allUn = row.tenantAllUninitialized === true || row.tenant_all_uninitialized === true;
      return !allUn;
    },
    tenantFieldIssuesForParser: function tenantFieldIssuesForParser() {
      if (this.currentEditId == null || this.currentEditId === '') {
        return [];
      }
      var row = this.integrityRow(this.currentEditId);
      var raw = row && (row.tenantFieldDetails || row.tenant_field_details);
      return Array.isArray(raw) ? raw : [];
    }
  },
  mounted: function mounted() {
    this.handlerGetTreeList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    yesNo: function yesNo(v) {
      return v ? '是' : '否';
    },
    /** 分类 extra 即绑定的表单模板 id；与展示行之间换行 */configKeyText: function configKeyText(node) {
      if (!node || node.extra === undefined || node.extra === null || node.extra === '') {
        return '';
      }
      return "formId\n".concat(node.extra);
    },
    l1ConfigKeyText: function l1ConfigKeyText(tab) {
      if (!tab) return '';
      if (tab.child && tab.child.length) {
        return "\u5206\u7C7B id\n".concat(tab.id);
      }
      return this.configKeyText(tab);
    },
    integrityRow: function integrityRow(extra) {
      if (extra === undefined || extra === null || extra === '') return null;
      return this.integrityMap[String(extra)] || null;
    },
    l1IntegrityTagClass: function l1IntegrityTagClass(tag) {
      if (!tag || !tag.show) return '';
      if (tag.kind === 'ok') return 'integrity-tag-ok';
      if (tag.kind === 'pending') return 'integrity-tag-warn';
      return 'integrity-tag-bad';
    },
    /** 默认侧已就绪且存在可补的缺失 name（含全空或仅缺新增字段）时展示 */showInitTenantButton: function showInitTenantButton(extra) {
      if (!this.checkPermi(['admin:system:config:save:form'])) {
        return false;
      }
      var row = this.integrityRow(extra);
      if (!row) return false;
      var canSync = row.tenantCanSyncMissingFromDefault === true || row.tenant_can_sync_missing_from_default === true;
      return canSync === true && row.defaultComplete === true;
    },
    initTenantLoadingFor: function initTenantLoadingFor(extra) {
      return !!this.initTenantLoadingIds[String(extra)];
    },
    handleFieldTenantInit: function handleFieldTenantInit(payload) {
      var _this = this;
      var fieldName = payload && (payload.fieldName || payload.field_name);
      if (!fieldName) return;
      if (!this.checkPermi(['admin:system:config:save:form'])) return;
      var formId = parseInt(this.currentEditId, 10);
      if (Number.isNaN(formId)) {
        this.$message.error('请先选择表单');
        return;
      }
      this.$confirm("\u5F53\u524D\u5404\u542F\u7528\u79DF\u6237\u5747\u672A\u6709\u914D\u7F6E\u9879\u300C".concat(fieldName, "\u300D\u3002\u5C06\u628A\u9ED8\u8BA4\u8868\u4E2D\u7684\u8BE5\u5B57\u6BB5\u5199\u5165\u6BCF\u4E2A\u79DF\u6237\uFF08\u4E0D\u8986\u76D6\u5176\u5B83\u5B57\u6BB5\uFF09\u3002\u662F\u5426\u7EE7\u7EED\uFF1F"), '初始化到各租户', {
        type: 'warning',
        confirmButtonText: '确定初始化',
        cancelButtonText: '取消'
      }).then(function () {
        var nameKey = String(fieldName);
        _this.syncingTenantFieldName = nameKey;
        systemSettingApi.systemConfigSyncTenantsFromDefault({
          formId: formId,
          name: nameKey
        }).then(function (count) {
          var n = typeof count === 'number' ? count : 0;
          _this.$message.success(n > 0 ? "\u5DF2\u4E3A\u5404\u79DF\u6237\u5199\u5165\u300C".concat(fieldName, "\u300D\u5171 ").concat(n, " \u6761") : '未写入（可能已存在）');
          _this.fetchIntegrity(_this.collectFormIdsFromTree(_this.treeList));
          if (String(_this.currentEditId) === String(formId)) {
            _this.handlerGetSettingInfo(formId, 2);
          }
        }).catch(function () {}).finally(function () {
          _this.syncingTenantFieldName = '';
        });
      }).catch(function () {});
    },
    handleInitTenantFromDefault: function handleInitTenantFromDefault(extra) {
      var _this2 = this;
      var formId = parseInt(extra, 10);
      if (Number.isNaN(formId)) {
        this.$message.error('表单 id 无效');
        return;
      }
      this.$confirm('将为各启用租户补插入默认表中本表单下「尚未存在的 name」对应行（含全新租户一次补全、或模板新增字段后仅补新字段）；已存在的 name 不会被覆盖。是否继续？', '初始化租户数据', {
        type: 'warning',
        confirmButtonText: '确定初始化',
        cancelButtonText: '取消'
      }).then(function () {
        var key = String(extra);
        _this2.$set(_this2.initTenantLoadingIds, key, true);
        systemSettingApi.systemConfigSyncTenantsFromDefault({
          formId: formId
        }).then(function (count) {
          var n = typeof count === 'number' ? count : 0;
          _this2.$message.success(n > 0 ? "\u5DF2\u4E3A\u672A\u521D\u59CB\u5316\u79DF\u6237\u63D2\u5165 ".concat(n, " \u6761\u914D\u7F6E") : '暂无需要初始化的租户');
          _this2.fetchIntegrity(_this2.collectFormIdsFromTree(_this2.treeList));
          if (String(_this2.currentEditId) === String(formId)) {
            _this2.handlerGetSettingInfo(formId, 2);
          }
        }).catch(function () {}).finally(function () {
          _this2.$delete(_this2.initTenantLoadingIds, key);
        });
      }).catch(function () {});
    },
    formIntegrityTag: function formIntegrityTag(extra) {
      var row = this.integrityRow(extra);
      if (!row && !this.integrityLoading) return {
        show: false,
        text: '',
        kind: 'ok'
      };
      if (!row) return {
        show: false,
        text: '',
        kind: 'ok'
      };
      var defOk = row.defaultComplete === true;
      var tenOk = row.tenantComplete === true;
      var canSync = row.tenantCanSyncMissingFromDefault === true || row.tenant_can_sync_missing_from_default === true;
      var extraBad = row.tenantHasExtraFieldKeys === true || row.tenant_has_extra_field_keys === true;
      if (defOk && tenOk) return {
        show: true,
        text: '完整',
        kind: 'ok'
      };
      if (defOk && !tenOk && canSync && !extraBad) return {
        show: true,
        text: '待初始化',
        kind: 'pending'
      };
      return {
        show: true,
        text: '异常',
        kind: 'error'
      };
    },
    l1IntegrityTag: function l1IntegrityTag(tab) {
      if (!tab || !tab.child || tab.child.length === 0) {
        return this.formIntegrityTag(tab && tab.extra);
      }
      var hasAny = false;
      var hasError = false;
      var hasPending = false;
      var _iterator = _createForOfIteratorHelper(tab.child),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var c = _step.value;
          var t = this.formIntegrityTag(c.extra);
          if (t.show) hasAny = true;
          if (t.kind === 'error') hasError = true;else if (t.kind === 'pending') hasPending = true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!hasAny) return {
        show: false,
        text: '',
        kind: 'ok'
      };
      if (hasError) return {
        show: true,
        text: '异常',
        kind: 'error'
      };
      if (hasPending) return {
        show: true,
        text: '待初始化',
        kind: 'pending'
      };
      return {
        show: true,
        text: '完整',
        kind: 'ok'
      };
    },
    buildTenantIssueTableRows: function buildTenantIssueTableRows(row) {
      var allUn = row && (row.tenantAllUninitialized === true || row.tenant_all_uninitialized === true);
      if (allUn) return [];
      var out = [];
      var details = row && (row.tenantFieldDetails || row.tenant_field_details) || [];
      details.forEach(function (ft) {
        var fname = ft.fieldName || ft.field_name;
        (ft.issues || []).forEach(function (iss) {
          out.push({
            fieldName: fname,
            tenantName: iss.tenantName || iss.tenant_name,
            tenantId: iss.tenantId != null ? iss.tenantId : iss.tenant_id,
            issue: iss.issue
          });
        });
      });
      return out;
    },
    openIntegrityDetail: function openIntegrityDetail(extra, side) {
      var row = this.integrityRow(extra);
      if (!row) {
        this.$message.info('暂无巡检数据，请稍后重试');
        return;
      }
      if (side === 'tenant') {
        var rows = this.buildTenantIssueTableRows(row);
        this.tenantIssueTableRows = rows;
        this.tenantIssueDialogTitle = "\u79DF\u6237\u914D\u7F6E \u2014 \u660E\u7EC6\uFF08".concat(row.formName || '表单', "\uFF0CformId ").concat(extra, "\uFF09");
        if (rows.length) {
          this.tenantIssueDialogEmptyText = '';
        } else {
          var allUn = row.tenantAllUninitialized === true || row.tenant_all_uninitialized === true;
          if (allUn && row.defaultComplete) {
            this.tenantIssueDialogEmptyText = '当前表单下各启用租户均无配置行，属正常「待初始化」场景；请点击工具栏「初始化租户数据」从默认配置复制。无需逐租户异常明细表。';
          } else {
            var _lines = row.tenantMessages || [];
            this.tenantIssueDialogEmptyText = _lines.length ? _lines.join('\n') : row.tenantComplete ? '各租户在该表单下字段均已对齐。' : '暂无逐字段明细，请稍后重新巡检。';
          }
        }
        this.tenantIssueDialogVisible = true;
        return;
      }
      var title = '默认配置';
      var ok = row.defaultComplete;
      var lines = row.defaultMessages || [];
      var body = lines.length ? lines.join('\n') : ok ? '与表单字段一致，数据完整。' : '校验未通过，请查看运维说明或联系开发人员。';
      this.$alert(body, title + ' — 明细', {
        confirmButtonText: '知道了'
      });
    },
    collectFormIdsFromTree: function collectFormIdsFromTree(list) {
      var ids = [];
      if (!list || !list.length) return ids;
      list.forEach(function (tab) {
        if (tab.child && tab.child.length) {
          tab.child.forEach(function (c) {
            var id = parseInt(c.extra, 10);
            if (!Number.isNaN(id)) ids.push(id);
          });
        } else if (tab.extra) {
          var id = parseInt(tab.extra, 10);
          if (!Number.isNaN(id)) ids.push(id);
        }
      });
      return _toConsumableArray(new Set(ids));
    },
    fetchIntegrity: function fetchIntegrity(formIds) {
      var _this3 = this;
      if (!formIds || !formIds.length) {
        this.integrityMap = {};
        return;
      }
      this.integrityLoading = true;
      systemSettingApi.systemConfigIntegrityCheck({
        formIds: formIds.join(',')
      }).then(function (data) {
        var map = {};
        var items = data && data.items || [];
        items.forEach(function (it) {
          if (it.formId != null) map[String(it.formId)] = it;
        });
        _this3.integrityMap = map;
      }).catch(function () {
        _this3.integrityMap = {};
      }).finally(function () {
        _this3.integrityLoading = false;
      });
    },
    handleTabClick: function handleTabClick(tab) {
      var inner = tab.$children[0];
      if (!inner || !inner.panes || !inner.panes.length) {
        return;
      }
      this.activeNamel2 = inner.panes[0].name;
      this.handlerGetLevel2FormConfig(this.activeNamel2);
    },
    handleItemTabClick: function handleItemTabClick(tab, event) {
      // 这里对tabs=tab.name和radio=id做了兼容
      var _id = tab.name ? tab.name : tab;
      if (!_id) return this.$message.error('表单配置不正确，请关联正确表单后使用');
      this.handlerGetLevel2FormConfig(_id);
    },
    handlerGetLevel2FormConfig: function handlerGetLevel2FormConfig(id) {
      var _this4 = this;
      var formPram = {
        id: id
      };
      this.currentEditId = id;
      this.formConfChild.content = {
        fields: []
      };
      this.formConfChild.render = false;
      this.loading = true;
      systemFormConfigApi.getFormConfigInfo(formPram).then(function (data) {
        var id = data.id,
          name = data.name,
          info = data.info,
          content = data.content;
        _this4.formConfChild.content = JSON.parse(content);
        if (id == 148) {
          _this4.formConfChild.content.fields.forEach(function (item) {
            item.disabled = true;
          });
          _this4.onlyCanView = true;
        } else {
          _this4.onlyCanView = false;
        }
        _this4.formConfChild.id = id;
        _this4.handlerGetSettingInfo(id, 2);
        _this4.loading = false;
      }).catch(function () {
        _this4.loading = false;
      });
    },
    handlerGetSettingInfo: function handlerGetSettingInfo(id, level) {
      var _this5 = this;
      systemSettingApi.systemConfigInfo({
        id: id
      }).then(function (data) {
        _this5.currentEditData = data;
        if (level === 1) {
          _this5.formConf.isEdit = _this5.currentEditData !== null;
          _this5.formConf.render = true;
        } else {
          _this5.formConfChild.isEdit = _this5.currentEditData !== null;
          _this5.formConfChild.render = true;
        }
      });
    },
    handlerSubmit: (0, _validate.Debounce)(function (formValue) {
      this.handlerSave(formValue);
    }),
    handlerSave: function handlerSave(formValue) {
      var _this6 = this;
      var _pram = this.buildFormPram(formValue);
      systemSettingApi.systemConfigSave(_pram).then(function (data) {
        _this6.$message.success('添加数据成功');
        var ids = _this6.collectFormIdsFromTree(_this6.treeList);
        _this6.fetchIntegrity(ids);
      });
    },
    handlerGetTreeList: function handlerGetTreeList() {
      var _this7 = this;
      var _pram = {
        type: this.$constants.categoryType[5].value,
        status: 1
      };
      this.loading = true;
      categoryApi.treeCategroy(_pram).then(function (data) {
        _this7.treeList = _this7.handleAddArrt(data);
        if (_this7.treeList.length > 0) _this7.activeNamel1 = _this7.treeList[0].id.toString();
        if (_this7.treeList.length > 0 && _this7.treeList[0].child.length > 0) {
          _this7.activeNamel2 = _this7.treeList[0].child[0].extra;
        }
        if (_this7.activeNamel2) {
          _this7.handlerGetLevel2FormConfig(_this7.treeList[0].child[0].extra);
        }
        var formIds = _this7.collectFormIdsFromTree(_this7.treeList);
        _this7.fetchIntegrity(formIds);
        _this7.loading = false;
      }).catch(function () {
        _this7.loading = false;
      });
    },
    handleAddArrt: function handleAddArrt(treeData) {
      var _result = selfUtil.addTreeListLabel(treeData);
      return _result;
    },
    buildFormPram: function buildFormPram(formValue) {
      var _pram = {
        fields: [],
        id: this.currentEditId,
        sort: 0,
        // 参数暂时无用
        status: true // 参数暂时无用
      };
      var _fields = [];
      Object.keys(formValue).forEach(function (key) {
        _fields.push({
          name: key,
          title: key,
          value: formValue[key]
        });
      });
      _pram.fields = _fields;
      return _pram;
    }
  }
};